var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',[_c('h1',[_vm._v("联系人管理系统")])]),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }